import {createStore} from "vuex"
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    state:{
        // webUrl:'http://localhost:8000', //本地开发或调试时用
        webUrl:'https://www.yixi365.com',  //上传到服务器时用
        username:"",
        sessionID:"",
        userID:"", //即后端返回的usertoken
        vip_date:"",
        last_login:"",
        folder_name:[],
        practise_nums:[],
        question_nums:[],
        words:[],
        word_assort_name:"",
        count_time:0,
        practise_count:0,
        question_time:0,
        question_count:0,
        FirstFileName:[],
        question_assort_name:"",       
        secondFileAssortName:"",
        questionSecondFileID:"",
        SecondFileName:[],

        multiplication:"",
        FileOrderAssort:[],
        setLeixingItem:{}, //存储检验的类型item数据
        setCheckItem:{}, //存储要加载的检验具体题目数据 
        setTestReportItem:{}, //存储检验报告数据
        emergencyTaskFileChoose:"",//存储紧急练习要提取的分组数据
        editQuestionItem:{}, //存储查询题卡点击要编辑的题卡
        // routerList:[], //存储路由路径
        setAccountData:{}, //存储账户信息
        setCountdownTimeStamp:"", //存储获取验证码60秒倒计时时间戳
        backUrl:"", //存储上一步的路由
        ManualDetail:"",//存储使用手册访问明细
        YuWenFileData:[]//语文年级数据
        
    },
    mutations:{
        setUserName(state, username){
            state.username = username
        },
        setSessionID(state, sessionID){
            state.sessionID = sessionID
        },
        setUserID(state, usertoken){
            state.userID = usertoken
        },
        setVipDate(state, vip_date){
            state.vip_date = vip_date
        },
        setLastLogin(state, last_login){
            state.last_login = last_login
        },
        
        setFolderName(state, folder_name){
            state.folder_name = folder_name
        },

        // 练习页面自动加载并保存词卡数据到本地待调用
        setPraNums(state, practise_nums){
            state.practise_nums = practise_nums  
        },

        // 练习页面自动加载并保存题卡数据到本地待调用
        setQueNums(state, question_nums){
            state.question_nums = question_nums  
        },


        setwords(state, words){
            state.words = words
        },
        setWordAssortName(state,word_assort_name){
            state.word_assort_name = word_assort_name
        },
        setCountTime(state,count_time){
            state.count_time = count_time
        },
        setPractiseCount(state,practise_count){
            state.practise_count = practise_count
        },
        setQuestionTime(state,question_time){
            state.question_time = question_time
        },
        setQuestionCount(state,question_count){
            state.question_count = question_count
        },
        setFirstFileName(state,FirstFileName){
            state.FirstFileName = FirstFileName
        },
        setQuestionAssortName(state,question_assort_name){
            state.question_assort_name = question_assort_name
        },
        setSecondFileAssortName(state,secondFileAssortName){
            state.secondFileAssortName = secondFileAssortName
        },
        setQuestionSecondFileID(state,questionSecondFileID){
            state.questionSecondFileID = questionSecondFileID
        },
        setSecondFileName(state,SecondFileName){
            state.SecondFileName = SecondFileName
        },
        setMultiplication(state,multiplication){
            state.multiplication = multiplication
        },
        setFileOrderAssort(state,FileOrderAssort){
            state.FileOrderAssort = FileOrderAssort  //存储文件夹排序类型“词卡文件夹排序/题卡初级分组排序/题卡二级分组排序”
        },
        setLeixingItem(state,item){
            state.setLeixingItem = item //存储检验的类型item数据
        },
        setCheckItem(state,item){
            state.setCheckItem = item //存储要加载的检验具体题目数据
        },
        setTestReportItem(state,item){
            state.setTestReportItem = item //存储检验报告数据
        },
        setEmergencyTaskFileChoose(state,fileChoose){
            state.emergencyTaskFileChoose = fileChoose //存储紧急练习要提取的分组数据
        },
        setEditQuestionItem(state,editQuestionItem){
            state.editQuestionItem = editQuestionItem //存储查询题卡点击要编辑的题卡
        },
        // setRouterList(state,routerList){
        //     state.routerList = routerList //存储路由路径是否可以进入
        // }
        setAccountData(state,accountData){
            state.setAccountData = accountData //存储账户信息
        },
        setCountdownTimeStamp(state,timeStamp){
            state.setCountdownTimeStamp = timeStamp //存储获取验证码60秒倒计时时间戳
        },
        setBackUrl(state,backUrl){
            state.backUrl = backUrl //存储上一步的路由
        },
        setManualDetail(state,item){
            state.ManualDetail = item //存储使用手册访问明细
        },
        setQueSurplusNum(state,item){
            state.question_nums.NewQueSurplusNum = item.NewQueSurplusNum;
            state.question_nums.OldQueSurplusNum = item.OldQueSurplusNum
        },
        setYuWenFileData(state,YuWenFileData){
            state.YuWenFileData = YuWenFileData //语文年级数据
        }
        
        



    },
    actions:{

    },
    modules:{

    },
    // 所有数据缓存到本地
    plugins:[createPersistedState()],
})
export default store



